import { headerBgWidth } from './HeaderBgStore.js';

export const updateHeaderBgWidth = (value) => headerBgWidth.update(oldValue => value);
